<template>
  <div class="insurance-intermediary-page">
    <UkaskoLoader
      :is-loading="!isInsuranceIntermediariesReady && !isTextBlocksReady('promo') && !isTextBlocksReady('insurance-intermediary') && !isCompanyProductsReady"
    >
      <div class="insurance-intermediary">
        <AppHeader
          class="insurance-intermediary__header"
          :animation-enabled="false"
          :is-mobile-menu-open="isMobileMenuOpen"
        />
        <div class="insurance-intermediary__background">
          <BackgroundCirclesTop class="insurance-intermediary__background-circles" />
          <Advantage class="insurance-intermediary__advantage insurance-intermediary__advantage--key"><KeyImage /></Advantage>
          <Advantage class="insurance-intermediary__advantage insurance-intermediary__advantage--puzzle"><PuzzlePieceImage /></Advantage>
          <Advantage class="insurance-intermediary__advantage insurance-intermediary__advantage--laptop"><LaptopImage /></Advantage>
          <BackgroundGradientTop class="insurance-intermediary__background-gradient" />
        </div>
        <div class="insurance-intermediary__title-block">
          <h2 class="insurance-intermediary__title" v-html="getTitleBlock('insurance-intermediary', 'header', 'title')"></h2>
        </div>

        <div class="insurance-intermediary__content">
          <Accordion class="insurance-intermediary__accordion" v-for="item in getInsuranceIntermediaries" :key="item.id">
            <template v-slot:title>
              <span class="insurance-intermediary__accordion-title">Страховий агент {{ item.name }}</span>
            </template>
            <ol class="insurance-intermediary__info-list">
              <li class="insurance-intermediary__info-item" v-for="(data, index) in item.info" :key="index">
                <h4 class="insurance-intermediary__info-title">{{ data.key }}</h4>
                <p v-if="!isValueSpecial(data.value)" class="insurance-intermediary__info-text" v-html="data.value"></p>
                <div v-if="data.value === '#[insurance_companies_list]'" class="insurance-intermediary__companies">
                  <InsuranceCompanyCard
                    v-for="company in getCompanyProducts(item.id)"
                    :key="company.company_id"
                    class="insurance-intermediary__company-card"
                    :title="company.name"
                    :route="{ name: 'insurance-companies' }"
                  >
                    {{ company.edrpou_code }}<br />
                    {{ company.post_code }}, {{ company.address }}<br />
                    {{ company.telephone }}
                  </InsuranceCompanyCard>
                </div>
              </li>
            </ol>
          </Accordion>
        </div>
        <div class="insurance-intermediary__footer"></div>
      </div>
      <div class="related-links">
        <div class="related-links__block">
          <div class="related-links__text-wrapper">
            <h4 class="related-links__title">Про страхові компанії</h4>
          </div>
          <VioletFancyButton class="related-links__button" :route="{ name: 'insurance-companies' }">
            <span class="related-links__button-text">Переглянути</span>
            <span class="related-links__button-icon"><RightArrow /></span>
          </VioletFancyButton>
        </div>
        <div class="related-links__footer"></div>
      </div>
      <AppFooter />
    </UkaskoLoader>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import BackgroundGradientTop from '../background-gradient-top';
import { textBlock } from '@/entities/text-block';
import { Accordion } from '@/shared/ui/accordion';
import { VioletFancyButton } from '@/shared/ui/form';
import { RightArrow } from '@/shared/ui/icons';
import {
  Advantage,
  BackgroundCirclesTop,
  InsuranceCompanyCard,
  KeyImage,
  LaptopImage,
  PuzzlePieceImage
} from '@/shared/ui/promo';
import { UkaskoLoader } from '@/shared/ui/ukasko-loader';
import { AppFooter, AppHeader, promoMobileMenu } from '@/widgets/promo';

export default {
  created() {
    this.fetchInsuranceIntermediaries();
    this.fetchCompanyProducts();
    this.fetchTextBlocks('promo');
    this.fetchTextBlocks('insurance-intermediary');
  },
  mixins: [ textBlock, promoMobileMenu ],
  components: {
    AppFooter, RightArrow, VioletFancyButton, AppHeader, BackgroundCirclesTop, Advantage, KeyImage, LaptopImage,
    PuzzlePieceImage, BackgroundGradientTop, Accordion, InsuranceCompanyCard, UkaskoLoader
  },
  computed: {
    ...mapGetters('promoInsuranceIntermediaryModule', ['isInsuranceIntermediariesReady', 'getInsuranceIntermediaries']),
    ...mapGetters('textBlocksModule', ['isTextBlocksReady']),
    ...mapGetters('promoCompanyProductsModule', ['isCompanyProductsReady', 'getCompanyProducts']),
  },
  methods: {
    ...mapActions('promoInsuranceIntermediaryModule', ['fetchInsuranceIntermediaries']),
    ...mapActions('textBlocksModule', ['fetchTextBlocks']),
    ...mapActions('promoCompanyProductsModule', ['fetchCompanyProducts']),
    isValueSpecial(value) {
      return ['#[insurance_companies_list]'].includes(value);
    },
  },
};
</script>

<style lang="scss" scoped>
.insurance-intermediary-page {
  background: linear-gradient(to bottom, #CADDFC 0px, #CADDFC 5px, rgba(202, 221, 252, 0.1) 100%);
}

.insurance-intermediary {
  position: relative;
  background-color: #CADDFC;
  padding-bottom: 95px;
  overflow: hidden;

  &__header {
    position: relative;
    z-index: 1;
  }

  &__background {
    position: relative;
  }

  &__background-circles {
    position: absolute;
    top: -291px;
    right: 0;
  }

  &__background-gradient {
    position: absolute;
    top: -270px;
    left: 50%;
    transform: translateX(-50%);
  }

  &__advantage {
    position: absolute;

    &--key {
      top: 0;
      left: 15%;
      opacity: 0.3;
    }

    &--puzzle {
      top: 90px;
      left: 6%;
      opacity: 0.2;
    }

    &--laptop {
      top: 75px;
      left: 22%;
      opacity: 0.3;

      @media (max-width: 720px) {
        opacity: 0;
      }
    }
  }

  &__title-block {
    position: relative;
    margin: 72px 12px 63px;

    @media (max-width: 700px) {
      margin-top: 40px;
    }
  }

  &__title {
    font-family: "IBM Plex Sans", sans-serif;
    font-size: 72px;
    font-weight: 500;
    color: #313437;
    text-align: center;
    margin-bottom: 16px;

    @media (max-width: 1050px) {
      font-size: 64px;
      margin-bottom: 16px;
    }

    @media (max-width: 800px) {
      font-size: 56px;
    }

    @media (max-width: 600px) {
      font-size: 44px;
    }

    @media (max-width: 500px) {
      font-size: 36px;
    }
  }

  &__content {
    position: relative;
    margin: 0 170px;

    @media (max-width: 1050px) {
      margin: 0 100px;
    }

    @media (max-width: 900px) {
      margin: 0 50px;
    }

    @media (max-width: 520px) {
      margin: 0 16px;
    }
  }

  &__accordion {
    @media (max-width: 720px) {
      margin-left: 16px;
      margin-right: 16px;
    }
  }

  &__accordion-title {
    font-family: 'Inter', sans-serif;
    font-size: 36px;
    font-weight: 400;
    color: #0C1421;

    @media (max-width: 1050px) {
      font-size: 32px;
    }

    @media (max-width: 700px) {
      font-size: 28px;
    }

    @media (max-width: 600px) {
      font-size: 24px;
    }
  }

  &__info-list {
    font-family: 'Inter', sans-serif;
    font-size: 36px;
    font-weight: 400;
    color: #0C1421;
    list-style-position: outside;
    list-style-type: decimal;
    padding-left: 55px;
  }

  &__info-title {
    font-family: 'Inter', sans-serif;
    font-size: 36px;
    font-weight: 400;
    color: #0C1421;
    margin-bottom: 16px;
  }

  &__info-text {
    font-family: 'Inter', sans-serif;
    font-size: 18px;
    font-weight: 400;
    color: #313957;
    margin-bottom: 16px;
  }

  &__companies {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  &__company-card {
    width: calc(33% - 16px);
    min-width: 250px;
    margin: 0 16px 16px 0;
  }

  &__footer {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 32px;
    background-color: #FCFDFF;
    border-radius: 32px 32px 0 0;
  }
}

.related-links {
  position: relative;
  display: flex;
  justify-content: center;
  padding: 95px 0 127px;
  background-color: #FCFDFF;
  overflow: hidden;

  @media (max-width: 1200px) {
    padding: 0 16px 64px;
  }

  @media (max-width: 800px) {
    flex-direction: column;
  }

  &__block {
    display: flex;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.5);
    padding: 24px;
    margin-right: 32px;
    border-radius: 32px;
    backdrop-filter: blur(24px);
    box-shadow: 0 14px 32px 0 #9199AE1C;

    @media (max-width: 800px) {
      margin-right: 0;
      margin-bottom: 32px;
      z-index: 2;
    }
  }

  &__title {
    font-family: "IBM Plex Sans", sans-serif;
    font-weight: 500;
    font-size: 22px;
    color: #494E53;
    margin-right: 24px;
  }

  &__button {
    @media (max-width: 600px), (min-width: 800px) and (max-width: 1050px) {
      padding: 10px;
      margin-left: 8px;
    }
  }

  &__button-text {
    @media (max-width: 600px), (min-width: 800px) and (max-width: 1050px) {
      display: none;
    }
  }

  &__button-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    background-color: #FFFFFF;
    border-radius: 50%;
    margin-left: 10px;

    @media (max-width: 600px), (min-width: 800px) and (max-width: 1050px) {
      margin-left: 0;
    }
  }

  &__footer {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 32px;
    background-color: #313437;
    border-radius: 32px 32px 0 0;
  }
}

::v-deep .accordion {
  &__header {
    background-color: #FCFDFF !important;
  }

  &__body {
    background-color: #FCFDFF !important;
  }
}
</style>
